<template>
  <div class="academy" style="margin-left: 240px;padding:20px;">
      <options />
      <futures />
  </div>
</template>

<script>
import options from './Options.vue';
import futures from './Futures.vue';

export default {
    components: {
        options,
        futures,
    },
    data(){
        return{
            loading: false
        }
    },
    methods: {
        sampleFunction() {
            //
        }
    },
    mounted() {
        //
    }
}
</script>
<style lang="scss">

</style>
